import { defineStore } from 'pinia'
import { ref } from 'vue'
import { api } from '../api'

const STORAGE_TOKEN = 'TOKEN'
const STORAGE_DEVICE_ID = 'device-uuid'

export function getToken(): string {
  return localStorage.getItem(STORAGE_TOKEN) || ''
}

export function setToken(token: string) {
  localStorage.setItem(STORAGE_TOKEN, token)
}

export function getDeviceId(): string {
  return localStorage.getItem(STORAGE_DEVICE_ID) || ''
}

function setDeviceId(id: string): string {
  localStorage.setItem(STORAGE_DEVICE_ID, id)
  return id
}

function generateUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

interface UserInfo {
  memberId: string
  memberName: string
  coinBalance: number
  vipEndTime: string
  code: string
  thirdNickName: string
  thirdHeadImgUrl: string
  headImageUrl: string
  thirdPartType: string
  subscribe: boolean
  subscribeType: number
  subscribeEndDate: string
  email: string
  autoLock: boolean
  subscribeRenewal: boolean
}

export const useUserStore = defineStore('user', () => {
  const userInfo = ref<UserInfo | null>(null)
  const isLoggedIn = ref(Boolean(getToken()))

  async function login(attributionRequest: Record<string, any> = {}) {
    let deviceId = getDeviceId()
    if (!deviceId)
      deviceId = setDeviceId(generateUUID())

    const res: any = await api.post('/member/login', {
      equipmentId: deviceId,
      attributionRequest,
    })
    const token = res?.data?.token
    if (token) {
      setToken(token)
      isLoggedIn.value = true
    }
  }

  async function fetchUserInfo() {
    try {
      const res: any = await api.get('/member/detail/get')
      if (res?.data) {
        userInfo.value = res.data
        isLoggedIn.value = true
      }
    }
    catch {
      // token 失效，清空
      localStorage.removeItem(STORAGE_TOKEN)
      isLoggedIn.value = false
    }
  }

  return { userInfo, isLoggedIn, login, fetchUserInfo }
})
